import { baseApi } from "./base.api";

export const brandsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBrands: build.query({
      query: (params) => ({ url: "/brands/fetch", method: "GET", params }),
      providesTags: ["Brand"],
    }),
    fetchBrandsAll: build.query({
      query: () => ({ url: "/brands/fetch/all", method: "GET" }),
      providesTags: ["Brand"],
    }),
    fetchTrashedBrands: build.query({
      query: (params) => ({ url: "/brands/fetch/trashed", method: "GET", params }),
      providesTags: ["Brand"],
    }),
    fetchBrandById: build.query({
      query: (id) => ({ url: `/brands/fetch/${id}`, method: "GET" }),
      providesTags: ["Brand"],
    }),
    createBrand: build.mutation({
      query: (body) => ({ url: "/brands/create", method: "POST", body }),
      invalidatesTags: ["Brand"],
    }),
    updateBrand: build.mutation({
      query: ({ id, body }) => ({ url: `/brands/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Brand"],
    }),
    changeBrandStatus: build.mutation({
      query: (id) => ({ url: `/brands/status/${id}`, method: "PUT" }),
      invalidatesTags: ["Brand"],
    }),
    restoreBrand: build.mutation({
      query: (id) => ({ url: `/brands/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Brand"],
    }),
    bulkRestoreBrands: build.mutation({
      query: (body) => ({ url: "/brands/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Brand"],
    }),
    deleteBrand: build.mutation({
      query: (id) => ({ url: `/brands/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Brand"],
    }),
    bulkDeleteBrands: build.mutation({
      query: (body) => ({ url: "/brands/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Brand"],
    }),
    destroyBrand: build.mutation({
      query: (id) => ({ url: `/brands/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Brand"],
    }),
    bulkDestroyBrands: build.mutation({
      query: (body) => ({ url: "/brands/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Brand"],
    }),
  }),
});

export const {
  useFetchBrandsQuery,
  useFetchBrandsAllQuery,
  useFetchTrashedBrandsQuery,
  useFetchBrandByIdQuery,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useChangeBrandStatusMutation,
  useRestoreBrandMutation,
  useBulkRestoreBrandsMutation,
  useDeleteBrandMutation,
  useBulkDeleteBrandsMutation,
  useDestroyBrandMutation,
  useBulkDestroyBrandsMutation,
} = brandsApi;
